<template>
    <div>
        <table width="100%" class="tableheatmap" v-if="chartDataOrdered">
            <tr>
                <th v-for="col in chartData.col_labels_rich" :width="col.width" @click="clickHeader(col)">
                  <strong>{{col.label}}</strong><span v-if="sort_field===col.label">{{arrow}}</span>
                </th>
            </tr>
            <tr v-for="row in chartDataOrdered.rows_display_ready">
                <td style="color:gray" v-if="row.show_row_num">{{row.row_num}}</td>
                <td class="first" style="text-align:right;"><strong>{{row.label}}</strong></td>
                <td class='editable' v-for="cell in row.cells" :style="'background-color:#fefefe;' + (cell.data_type==='numeric' ? 'text-align:right;padding-right:10px;' : '')">
                      <div v-if="cell.editable">
                        <TableCustomEditableCell
                            :value="cell.value"
                            :row_label="row.label"
                            :cell_label="cell.label"
                            :category_field_set_id="cell.category_field_set_id"
                            :extent_id="extent_id"
                          />
                      </div>
                      <div v-else>
                        <div v-if="cell.data_type==='url'">
                          <a :href="cell.value" target="_blank">{{cell.value}}</a>
                        </div>
                        <div v-else-if="cell.data_type==='list'">
                          <ul>
                            <li v-for="item in cell.list_values" style="text-align:left!important">{{item}}</li>
                          </ul>
                        </div>
                        <div v-else>
                           {{cell.value}}
                        </div>
                      </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "TableCustom",
        props: ['height','width', 'text_size', 'chartData','extent_id'],
        data() {
          return {
            sort_field: null,
            sort_direction: 'desc',
            chartDataOrdered: null,
            arrow: '+'
          }
        },
        computed: {
            cellWidth: function () {
                let percent = 100 / this.chartData.col_labels_display_ready.length
                return percent.toString() + '%'
            },
        },
        mounted() {
          this.chartDataOrdered =  JSON.parse(JSON.stringify(this.chartData))
        },
        watch: {
            chartData: function () {
                this.chartDataOrdered =  JSON.parse(JSON.stringify(this.chartData))
            },
        },
        methods: {
            click(row,column) {
                let payload = {
                    label: row,
                    color: column
                }
                this.$emit('stackChartClicked',payload);
            },
            clickHeader(col) {
              if (col.label!==this.sort_field) {
                this.sort_field = col.label
                this.sort_direction = 'desc'
                this.arrow = '↓'
              } else if (this.sort_direction === 'desc') {
                this.sort_direction = 'asc'
                this.arrow = '↑'
              } else {
                this.sort_field = null
                this.arrow = ''
                this.chartDataOrdered =  JSON.parse(JSON.stringify(this.chartData))
                return
              }
              let column_position = this.chartData.col_labels_display_ready.findIndex((element) => {
                return col.label===element
              })

              let is_row_number_column = false
              let is_row_label_column = false
              console.log('col label is /' + col.label +'/')
              if (col.label==='#') {
                is_row_number_column = true
                console.log('setting is_row_number_column to true')
              }
              let col_offset = -1
              if (this.chartData.rows_display_ready[0].show_row_num) {
                is_row_label_column = column_position === 1
                col_offset = -2
              } else {
                is_row_label_column = column_position===0
              }

              column_position = column_position + col_offset

              console.log('is_row_number_column=' + is_row_number_column + ' and is_row_label_column=' + is_row_label_column)

              console.log('position is ' + column_position)
              this.chartDataOrdered.rows_display_ready = this.chartDataOrdered.rows_display_ready.sort((a,b) => {
                let return_value = 0
                if (is_row_label_column) {
                  return_value = a.label < b.label
                } else if (is_row_number_column) {
                  return_value = +a.row_num < +b.row_num
                } else {
                  let a_value = a.cells[column_position].value
                  let b_value = b.cells[column_position].value
                  if (a.cells[column_position].data_type==='numeric') {
                    a_value = +a_value
                    b_value = +b_value
                  }
                  return_value = a_value < b_value
                }
                if (this.sort_direction === 'asc') return_value = !return_value
                return_value = return_value ? 1 : -1
                return return_value
              })

            }
        }
    }
</script>

<style scoped>

</style>